<template>
  <div class="workflowColumn">
    <section class="workflowBox">
      <div class="workflowItem" @click="setWorkFlow">
        <div
          class="workflowAvatars"
          :class="
            _.get(workFlow, 'extra.isGray') ? [workFlowStyle.avatarBg] : [workFlowStyle.nameBg]
          "
        >
          <svg-icon :icon-class="workFlowStyle.avatarIcon"></svg-icon>
        </div>
        <template v-if="!previewMode">
          <i
            v-if="workFlow.type != 'workFlowStart'"
            class="el-icon-error workflowNodeDel"
            @click.stop="deleteNode"
          ></i>
        </template>
        <div class="workflowName" :class="[workFlowStyle.nameBg]">
          <span v-tip>{{ workFlow.name }}</span>
        </div>
        <div v-if="workFlow.type === 'workFlowStart'">
          <div v-if="workFlow.trigger.type === 'START_TYPE_DATA'" class="workflowContent">
            <template v-if="_.get(workFlow, 'trigger.extra.description.sheetName')">
              <div class="preview-row common-row">
                <span class="label">工作表：</span>
                <span v-tip class="value">
                  {{ _.get(workFlow, "trigger.extra.description.sheetName") }}
                </span>
              </div>
              <div class="common-tip">
                {{ _.get(workFlow, "trigger.extra.description.operation") }}
              </div>
            </template>
            <div v-else class="empty">设置此节点</div>
          </div>
          <div v-else-if="workFlow.trigger.type === 'START_TYPE_TIME'" class="workflowContent">
            <template v-if="_.get(workFlow, 'trigger.extra.description.sheetName')">
              <div class="preview-row common-row">
                <span class="label">工作表：</span>
                <span v-tip class="value">
                  {{ _.get(workFlow, "trigger.extra.description.sheetName") }}
                </span>
              </div>
              <div class="common-tip">
                {{ _.get(workFlow, "trigger.extra.description.time") }}
              </div>
            </template>
            <div v-else class="empty">设置此节点</div>
          </div>
          <div v-else-if="workFlow.trigger.type === 'START_TYPE_CRON'" class="workflowContent">
            <template v-if="_.get(workFlow, 'trigger.extra.description.expression')">
              <div class="preview-row">
                <span class="label">表达式：</span>
                <span class="value" v-tip>
                  {{ _.get(workFlow, "trigger.extra.description.expression") }}
                </span>
              </div>
            </template>
            <div v-else class="empty">设置此节点</div>
          </div>
          <div v-else-if="workFlow.trigger.type === 'START_TYPE_SUB'" class="workflowContent">
            <template v-if="dataSource && workFlowName">
              <div class="preview-row common-row">
                <span class="label">数据源：</span>
                <span class="value" v-tip>
                  {{ dataSource }}
                </span>
              </div>
              <div class="common-tip">
                <span class="value" v-tip>
                  {{ workFlowName }}
                </span>
              </div>
            </template>
            <div v-else class="empty">设置此节点</div>
          </div>
          <div v-else-if="workFlow.trigger.type === 'START_TYPE_BTN'" class="workflowContent">
            <template v-if="sheetInfo.name">
              <div class="preview-row common-row">
                <span class="label">工作表：</span>
                <span v-tip class="value">{{ sheetInfo.name }}</span>
              </div>
              <div class="preview-row common-row">
                <span class="label">按钮：</span>
                <span v-tip class="value">{{ workFlow.trigger.sheetBtn.name }}</span>
              </div>
              <div class="common-tip">点击按钮后立即执行</div>
            </template>
            <div v-else class="empty">设置此节点</div>
          </div>
          <div v-else-if="workFlow.trigger.type === 'START_TYPE_VALIDATE'" class="workflowContent">
            <template v-if="sheetInfo.name">
              <div class="preview-row common-row">
                <span class="label">工作表：</span>
                <span class="value" v-tip>
                  {{ sheetInfo.name }}
                </span>
              </div>
            </template>
            <div v-else class="empty">设置此节点</div>
          </div>
          <div v-else-if="workFlow.trigger.type === 'START_TYPE_HTTP'" class="workflowContent">
            <template v-if="_.get(workFlow, 'trigger.extra.description.state')">
              <div class="preview-row">
                {{ _.get(workFlow, "trigger.extra.description.state") }}
              </div>
            </template>
            <div v-else class="empty">设置此节点</div>
          </div>
          <div v-else class="workflowContent">
            <div class="empty">设置此节点</div>
          </div>
        </div>
        <div
          v-else-if="
            workFlow.type === 'ServiceNotify' &&
              mailNotify !== undefined &&
              mailNotify !== 'undefined'
          "
          class="workflowContent"
        >
          <div class="preview-row">
            <span class="label">通知对象：</span>
            <span v-tip class="value">
              {{ mailNotify }}
            </span>
          </div>
          <div class="preview-row">
            <span class="label">通知类型：</span>
            <span class="value">{{ workFlow.extra.notifyMethod }}</span>
          </div>
        </div>
        <div v-else-if="workflowType.data === 'project'" class="workflowContent">
          <template v-if="showPreviewInfo">
            <template v-if="workFlow.type == 'workFlowStart'">任务完成时触发</template>
            <template
              v-else-if="
                workFlow.type === 'UserVerify' &&
                  _.get(workFlow, 'extra.description.originator') &&
                  _.get(workFlow, 'extra.description.candidates')
              "
            >
              <div class="preview-row">
                <span class="label">发起人：</span>
                <span class="value">{{ _.get(workFlow, "extra.description.originator") }}</span>
              </div>
              <div class="preview-row">
                <span class="label">审批人：</span>
                <span class="value">{{ _.get(workFlow, "extra.description.candidates") }}</span>
              </div>
            </template>
          </template>
          <template v-else><div class="empty">设置此节点</div></template>
        </div>
        <div v-else-if="workFlow.type === 'UserVerify'" class="workflowContent">
          <template
            v-if="
              _.get(workFlow, 'extra.description.originator') &&
                _.get(workFlow, 'extra.description.candidates')
            "
          >
            <div class="preview-row">
              <span class="label">发起人：</span>
              <span class="value" v-tip>{{ _.get(workFlow, "extra.description.originator") }}</span>
            </div>
            <div class="preview-row">
              <span class="label">审批人：</span>
              <span class="value" v-tip>{{ _.get(workFlow, "extra.description.candidates") }}</span>
            </div>
          </template>
          <template v-else><div class="empty">设置此节点</div></template>
        </div>
        <div
          v-else-if="
            workFlow.type === 'ServiceNumCompute' && _.get(workFlow, 'extra.description.expression')
          "
          class="workflowContent"
        >
          <div class="preview-row">
            <span class="label">计算表达式：</span>
            <span class="value" v-tip>{{ _.get(workFlow, "extra.description.expression") }}</span>
          </div>
        </div>
        <div
          v-else-if="
            workFlow.type === 'ServiceDateCompute' &&
              _.get(workFlow, 'extra.description.expression')
          "
          class="workflowContent"
        >
          <div class="preview-row">
            <span class="label">计算表达式：</span>
            <span class="value" v-tip>{{ _.get(workFlow, "extra.description.expression") }}</span>
          </div>
        </div>
        <div
          v-else-if="
            workFlow.type === 'ServiceSheetCompute' &&
              _.get(workFlow, 'extra.description.sheetName') &&
              _.get(workFlow, 'extra.description.expression')
          "
          class="workflowContent"
        >
          <div class="preview-row common-row" style="margin-bottom: 10px">
            <span class="label">工作表：</span>
            <span v-tip class="value">{{ _.get(workFlow, "extra.description.sheetName") }}</span>
          </div>
          <div class="preview-row">
            <span class="label">计算表达式：</span>
            <span class="value" v-tip>{{ _.get(workFlow, "extra.description.expression") }}</span>
          </div>
        </div>
        <div
          v-else-if="
            workFlow.type === 'TimerDelay' && _.get(workFlow, 'extra.description.expression')
          "
          class="workflowContent"
        >
          <div class="preview-row">
            <span class="label">延时表达式：</span>
            <span class="value" v-tip>{{ _.get(workFlow, "extra.description.expression") }}</span>
          </div>
        </div>
        <div
          v-else-if="
            workFlow.type === 'SubProcessRes' && _.get(workFlow, 'extra.description.expression')
          "
          class="workflowContent"
        >
          <div class="preview-row">
            <span class="label">输出参数：</span>
            <span class="value" v-tip>{{ _.get(workFlow, "extra.description.expression") }}</span>
          </div>
        </div>
        <div
          v-else-if="
            workFlow.type === 'ServiceDataSync' && _.get(workFlow, 'extra.description.syncRule')
          "
          class="workflowContent"
        >
          <div class="preview-row">
            <span class="label">同步规则：</span>
            <span class="value" v-tip>{{ _.get(workFlow, "extra.description.syncRule") }}</span>
          </div>
        </div>
        <div v-else-if="workFlow.type === 'SubProcess'" class="workflowContent">
          <template v-if="_.get(workFlow, 'extra.description.subProcessName')">
            <div class="preview-row">
              <span class="label">执行工作流：</span>
              <span class="value">
                {{ _.get(workFlow, "extra.description.subProcessName") }}
                <i
                  class="el-icon-link"
                  style="color: #409EFF"
                  @click="editSubProcess(_.get(workFlow, 'extra.description.subProcessId'))"
                ></i>
              </span>
            </div>
          </template>
          <template v-else><div class="empty">设置此节点</div></template>
        </div>
        <div v-else-if="workFlow.type === 'ServiceInsertSheet'" class="workflowContent">
          <template v-if="_.get(workFlow, 'extra.description.sheetName')">
            <div class="preview-row common-row">
              <span class="label">工作表：</span>
              <span v-tip class="value">{{ _.get(workFlow, "extra.description.sheetName") }}</span>
            </div>
            <div class="common-tip">在工作表中新增数据</div>
          </template>
          <div v-else class="empty">设置此节点</div>
        </div>
        <div v-else-if="workFlow.type === 'ServiceUpdateSheet'" class="workflowContent">
          <template v-if="_.get(workFlow, 'extra.sheetName')">
            <div class="preview-row common-row">
              <span class="label">工作表：</span>
              <span v-tip class="value">{{ _.get(workFlow, "extra.sheetName") }}</span>
            </div>
            <div class="preview-row common-row">
              <span class="label">更新对象：</span>
              <span v-tip class="value">{{ _.get(workFlow, "extra.updateField") }}</span>
            </div>
            <div class="common-tip">在工作表中更新数据</div>
          </template>
          <div v-else class="empty">设置此节点</div>
        </div>
        <div v-else-if="workFlow.type === 'ServiceDeleteSheet'" class="workflowContent">
          <template v-if="_.get(workFlow, 'extra.description.sheetName')">
            <div class="preview-row common-row">
              <span class="label">工作表：</span>
              <span v-tip class="value">{{ _.get(workFlow, "extra.description.sheetName") }}</span>
            </div>
            <div class="preview-row common-row">
              <span class="label">删除对象：</span>
              <span v-tip class="value">{{ _.get(workFlow, "extra.description.deleteVar") }}</span>
            </div>
            <div class="common-tip">在工作表中删除数据</div>
          </template>
          <div v-else class="empty">设置此节点</div>
        </div>
        <div v-else-if="workFlow.type === 'ServiceSearchMulti'" class="workflowContent">
          <template v-if="_.get(workFlow, 'extra.description.sheetName')">
            <div class="preview-row common-row">
              <span class="label">工作表：</span>
              <span v-tip class="value">{{ _.get(workFlow, "extra.description.sheetName") }}</span>
            </div>
            <div class="common-tip">
              在工作表中查找{{ _.get(workFlow, "extra.description.oneFlag") }}
            </div>
          </template>
          <div v-else class="empty">设置此节点</div>
        </div>
        <div
          v-else-if="['ServiceSetPart', 'ServiceLock'].includes(workFlow.type)"
          class="workflowContent"
        >
          <template v-if="_.get(workFlow, 'extra.description.sheetName')">
            <div class="preview-row common-row">
              <span class="label">工作表：</span>
              <span v-tip class="value">{{ _.get(workFlow, "extra.description.sheetName") }}</span>
            </div>
            <div class="preview-row common-row">
              <span class="label">操作对象：</span>
              <span v-tip class="value">{{ _.get(workFlow, "extra.description.target") }}</span>
            </div>
            <div class="common-tip">{{ _.get(workFlow, "extra.description.operation") }}</div>
          </template>
          <div v-else class="empty">设置此节点</div>
        </div>
        <div v-else-if="workFlow.type === 'ServiceValidate'" class="workflowContent">
          <template v-if="!_.isEmpty(_.get(workFlow, 'extra.description.messages'))">
            <div class="preview-row common-row" style="flex-flow: column;">
              <div
                v-tip
                class="value"
                v-for="(item, index) in _.get(workFlow, 'extra.description.messages')"
                :key="index"
              >
                <span class="label">{{ index + 1 + "、" }}</span>
                {{ item }}
              </div>
            </div>
            <div class="common-tip">满足任一条件，则阻断操作</div>
          </template>
          <div v-else class="empty">设置此节点</div>
        </div>
        <div
          v-else-if="['ServiceScript', 'ServiceHttp'].includes(workFlow.type)"
          class="workflowContent"
        >
          <template v-if="_.get(workFlow, 'extra.description.state')">
            <div class="preview-row">
              <span class="label">{{ _.get(workFlow, "extra.description.state") }}</span>
            </div>
          </template>
          <div v-else class="empty">设置此节点</div>
        </div>
        <div v-else-if="workFlow.type === 'ServiceGetUser'" class="workflowContent">
          <div v-if="!_.get(workFlow, 'extra.isGray')" style="color: #333">从组织架构查找</div>
          <div v-else class="empty">设置此节点</div>
        </div>
        <div v-else-if="workFlow.type === 'ServicePdf'" class="workflowContent">
          <template
            v-if="
              _.get(workFlow, 'extra.description.printData') &&
                _.get(workFlow, 'extra.description.printTemplate')
            "
          >
            <div class="preview-row">
              <span class="label">打印数据：</span>
              <span class="value" v-tip>{{ _.get(workFlow, "extra.description.printData") }}</span>
            </div>
            <div class="preview-row">
              <span class="label">打印模板：</span>
              <span class="value" v-tip>
                {{ _.get(workFlow, "extra.description.printTemplate") }}
              </span>
            </div>
          </template>
          <div v-else class="empty">设置此节点</div>
        </div>
        <div v-else-if="workFlow.type === 'UserSeal'" class="workflowContent">
          <div v-if="!_.get(workFlow, 'extra.isGray')" style="color: #333">已配置</div>
          <div v-else class="empty">设置此节点</div>
        </div>
        <div v-else class="workflowContent">
          <div class="empty">设置此节点</div>
        </div>
      </div>
      <div class="workflowLineBtn">
        <div v-if="!previewMode" class="icon-add" @click="openInsertNode">
          <i class="el-icon-circle-plus-outline"></i>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { getAllSheet, getAvailableSheets } from "@/api/sheet/sheet"
import { EventBus } from "../eventBus"
import { workflowStyleMap } from "@/views/Backend/AdminEdit/Workflow/components/static"
import { getMainProcess } from "@/api/workflow/workflow"

export default {
  name: "workFlowItem",
  inject: ["workflowType", "previewMode"],
  props: {
    workFlow: Object,
    controlTypeMap: Object
  },
  data() {
    return {
      styleMap: workflowStyleMap,
      allSheet: [],
      sheetInfo: {},
      availableSheets: [],
      workFlows: []
    }
  },
  computed: {
    workFlowStyle() {
      let style = ""
      switch (this.workFlow.type) {
        case "workFlowStart": {
          style = this.styleMap.workFlowStart[this.workFlow.trigger.type]
          break
        }
        case "ServiceDateCompute":
        case "ServiceSheetCompute":
        case "ServiceNumCompute": {
          style = this.styleMap.ServiceCompute
          break
        }
        default:
          style = this.styleMap[this.workFlow.type]
      }
      return style
    },
    mailNotify() {
      let candidates = this.workFlow.extra.candidates
      let emailDefsExtra = this.workFlow.extra?.emailDefsExtra
        ? this.workFlow.extra?.emailDefsExtra.map(e => e.label).join("，")
        : ""
      let mailMessage = this.workFlow.data?.mailMessage?.emails
        ? this.workFlow.data.mailMessage?.emails.join("，")
        : ""
      return candidates + emailDefsExtra + mailMessage
    },
    showPreviewInfo() {
      if (this.workflowType.data == "app") return false
      if (this.workFlow.type == "workFlowStart") return true
      if (!this.workFlow.extra) return false
      if (this.workFlow.type == "UserVerify") {
        if (
          this.workFlow.extra.originator ||
          this.workFlow.extra.candidates ||
          this.workFlow.extra.verifyMethod
        )
          return true
      } else if (this.workFlow.type == "ServiceNotify") {
        if (this.workFlow.extra.notifyMethod || this.workFlow.extra.candidates) return true
      }
      return false
    },
    searchSheetMap() {
      let map = {}
      this.availableSheets.forEach(item => {
        item.sheets.forEach(sheet => (map[sheet.sheetId] = sheet.name))
      })
      return map
    },
    dataSource() {
      if (this.workFlow.trigger.control._type === "ref") {
        return this.searchSheetMap?.[this.workFlow.trigger.control.refSheetId]
      } else {
        return this.controlTypeMap?.[this.workFlow.trigger.control._type]?.name
      }
    },
    workFlowName() {
      if (this.workFlows.length) {
        let name = this.workFlows[0].name
        this.workFlows.slice(1).forEach(workFlow => (name = name + "，" + workFlow.name))
        return '被"' + name + '工作流"触发'
      } else {
        return "未被任何工作流触发"
      }
    },
    appId() {
      return this.workflowType.id
    }
  },
  watch: {
    "workFlow.trigger.sheetId": {
      handler: function(newVal, oldVal) {
        if (newVal && newVal != oldVal) {
          this.getAllSheet().then(() => {
            this.sheetInfo = this.allSheet.find(i => i.sheetId === this.workFlow.trigger.sheetId)
          })
        }
      },
      immediate: true
    }
  },
  created() {
    if (this.workFlow.trigger?.type === "START_TYPE_SUB") {
      this.getAvailableSheets()
      this.getWorkFlows()
    }
  },
  methods: {
    getAllSheet() {
      return getAllSheet(this.appId).then(sheetDefs => (this.allSheet = sheetDefs))
    },
    getAvailableSheets() {
      getAvailableSheets({ appId: this.appId }).then(availableSheets => {
        this.availableSheets = availableSheets
      })
    },
    getWorkFlows() {
      getMainProcess(this.workFlow.id).then(res => {
        this.workFlows = res
      })
    },
    setWorkFlow() {
      EventBus.$emit("openSetting", {
        workFlow: this.workFlow
      })
    },
    openInsertNode() {
      EventBus.$emit("openInsertNode", {
        workFlow: this.workFlow
      })
    },
    deleteNode() {
      EventBus.$emit("deleteNode", {
        workFlow: this.workFlow
      })
    },
    editSubProcess(id) {
      const { href } = this.$router.resolve({
        name: "admin-edit-workflow",
        query: { id: id }
      })
      window.open(href, "_blank")
    }
  }
}
</script>

<style lang="scss" scoped>
.workflowColumn {
  display: flex;
  align-items: center;
  position: relative;
  flex-direction: column;
  .workflowBox {
    padding: 20px 50px 0;
    position: relative;
    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      width: 1px;
      height: 100%;
      background-color: #ccc;
    }
    .workflowItem {
      width: 280px;
      background: #fff;
      border-radius: 6px;
      position: relative;
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.16);
      display: flex;
      flex-direction: column;
      cursor: pointer;
      &:hover {
        .workflowNodeDel {
          display: inline-block;
        }
      }
      .workflowAvatars {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: -20px;
        left: 0;
        right: 0;
        height: 40px;
        width: 40px;
        margin: auto;
        border-radius: 50%;
        border: 2px solid #fff;
        z-index: 3;
        pointer-events: none;
        font-size: 20px;
        color: #fff;
      }
      .workflowNodeDel {
        color: #757575;
        cursor: pointer;
        position: absolute;
        top: -8px;
        right: -10px;
        font-size: 22px;
        width: 22px;
        height: 22px;
        background: #fff;
        border-radius: 50%;
        display: none;
        z-index: 10;
        &:hover {
          color: #f44336;
        }
      }
      .workflowName {
        width: 100%;
        height: 60px;
        position: relative;
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;
        font-size: 15px;
        color: #fff;
        padding: 26px 10px 0;
        box-sizing: border-box;
        text-align: center;
      }
      .workflowContent {
        padding: 8px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        min-height: 34px;
        font-size: 13px;
        .workflowContentInfo {
          height: 30px;
          line-height: 30px;
          padding: 0 8px;
          width: 100%;
          box-sizing: border-box;
          font-size: 13px;
        }
        .workflowContentBG {
          background: #f5f5f5;
        }
        .mTop4 {
          margin-top: 4px;
        }
        .preview-row {
          display: flex;
          .label {
            flex-shrink: 0;
            color: #333;
          }
          .value {
            flex: 1 1;
            color: #888;
          }
        }
        .common-row {
          line-height: 32px;
          background: #f5f5f5;
          padding: 0 8px;
        }
        .common-tip {
          color: #333;
          margin-top: 10px;
        }
        .empty {
          padding-left: 8px;
          color: #2196f3;
        }
      }
    }
    .workflowLineBtn {
      padding: 20px 0;
      width: 280px;
      position: relative;
      .icon-add {
        width: 24px;
        height: 20px;
        display: block;
        font-size: 24px;
        line-height: 22px;
        cursor: pointer;
        position: relative;
        background: #f5f5f5;
        color: #ccc;
        margin: 0 auto;
        &:hover {
          color: #757575;
        }
        i {
          margin-top: -2px;
        }
      }
    }
  }
  .branchItem::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 1px;
    height: 100%;
    background-color: #ccc;
  }
}
</style>
